export const capitalize = phrase => {
  return phrase?.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
};
